import styled from 'styled-components';

import { colors } from '../constants';

/**
 * A small primary-text-colored anchor tag, used for file downloads
 * Outlines itself when focused
 */
export default styled.a`
  color: ${colors.TEXT_PRIMARY};
  text-decoration: underline;
  margin-right: auto;
  &:focus {
    outline: 0.0625rem solid ${colors.TEXT_PRIMARY};
    border-radius: 0.25rem;
    margin: auto 0.125rem;
    text-decoration: none;
  }
`;
